var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.sorted),function(status){return _c('div',{key:status.id},[_c('p',[_c('span',{staticClass:"has-text-weight-semibold"},[_vm._v(_vm._s(status.dynamic_status.name)+":")]),_vm._v(" "+_vm._s(status.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }